import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import { getPaginatedSubscriptionsIfNeeded, updateResubscribeIfNeeded, getUnsubscribeCount } from './sagas';
import { getAllActiveCampaignsIfNeeded } from '../campaign/sagas';
import {
  GET_PAGINATED_SUBSCRIPTIONS,
  GETTING_PAGINATED_SUBSCRIPTIONS_FAILED,
  UPDATE_RESUBSCRIBE,
  GET_UNSUBSCRIBE_COUNT
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest([GETTING_PAGINATED_SUBSCRIPTIONS_FAILED], function*(action) {
    yield put(
      userMessaging.setMessageForFailedAction({
        type: action.type,
        error: action.payload
      })
    );
  });
}

/* APP FLOW - Templates */
function* PaginatedSubscriptionsGetManySaga() {
  yield takeLatest(GET_PAGINATED_SUBSCRIPTIONS, function*(action) {
    yield call(waitForUserReady);
    yield call(getAllActiveCampaignsIfNeeded, action);
    yield call(getPaginatedSubscriptionsIfNeeded, action);
  });
}

function* UpdateResubscribeSaga() {
  yield takeLatest(UPDATE_RESUBSCRIBE, function*(action) {
    yield call(waitForUserReady);
    yield call(updateResubscribeIfNeeded, action);
  });
}

function* GetUnsubscribeCountSaga() {
  yield takeLatest(GET_UNSUBSCRIBE_COUNT, function*(action) {
    yield call(waitForUserReady);
    yield call(getUnsubscribeCount, action);
  });
}

export default [
  HandleFailuresSaga,
  PaginatedSubscriptionsGetManySaga,
  UpdateResubscribeSaga,
  GetUnsubscribeCountSaga
];
